<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Col, Row, SelectCard, Text, Alert } from '@Shelly/shelly-design-system';
	//Helpers
	import {
		getVirtualComponent,
		getVirtualComponentsInterface,
		virtualBthomeTranslationValues,
	} from 'src/helpers/virtual_helpers/virtual_components_helpers';
	import { getVirtualIconStatus } from 'src/helpers/virtual_helpers/virtual_icons_helpers';
	import { saveGroupComponents } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_helpers';
		//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: settingsStore = getDeviceSettings(device.id);
	export let device: Device;
	export let component: string = null;
	export let selectedItems: string[] = [];
	export let components: VirtualComponentInterface[] = null;

	export const save = async (groupID: number): Promise<SettingRequest> => {
		return saveGroupComponents(device, groupID, selectedItems);
	};

	selectedItems = component ? getVirtualComponent(device.id, component)?.status?.value || [] : [];

	if (!components) {
		components = getVirtualComponentsInterface(device.id).filter((i) => !i?.config?.owner);
	}

	const getDeviceVirtualComponents = (_deviceSettings: DeviceSettingsG2) => {
		components = getVirtualComponentsInterface(device.id).filter((i) => !i?.config?.owner);
		if (selectedItems) {
			selectedItems = selectedItems.filter((i) => components.find((c) => i == c.key));
		}
	};

	const onSelectComponent = (component: string) => {
		if (selectedItems.indexOf(component) == -1) {
			selectedItems.push(component);
			selectedItems = selectedItems;
		} else {
			selectedItems = selectedItems.filter((item) => item != component);
		}
	};

	$: getDeviceVirtualComponents($settingsStore);
</script>

<Text element="h2" class="text-capitalize mb-m">
	{$format('settings_title_virtual_components', {
		default: 'Virtual Components',
	})}
</Text>
{#if !components?.length}
	<Alert
		type="info"
		class="mb-m"
		heading={$format('no_virtual_components_title_new', {
			default: 'There are no {components} yet',
			values: {
				components: virtualBthomeTranslationValues(device.type),
			},
		})}
	/>
{/if}
<Row class="mb-m">
	{#each components as component (component.key)}
		<Col xs="12" md="6">
			{@const icon = getVirtualIconStatus(
				null,
				component?.key?.split(':')?.[0],
				component?.config,
			)}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				title={component?.config?.name || component.key}
				variant={'checkbox'}
				image={component?.config?.meta?.ui?.icon ? component.config.meta.ui.icon : undefined}
				size="s"
				type="horizontal"
				icon={icon?.icon || 'fas fa-cube'}
				descriptiveText={`${icon?.title || component.key} ${component.config?.addr || ''}`}
				selected={selectedItems.indexOf(component.key) >= 0}
				on:click={() => onSelectComponent(component.key)}
			/>
		</Col>
	{/each}
</Row>
